/** The whole path. A caller checks the length first, so the pattern never runs on an over-length text. */
const REQUEST_PATH_PATTERN = new RegExp(`^/v1(?:/(?:[A-Za-z0-9._~-]|%[0-9A-Fa-f]{2})+)+$`);
/**
* True when `segment` is `.` or `..` after `%2e` and `%2E` read as `.`.
*
* @param segment one path segment, with no `/`.
*/
function isDotSegment(segment) {
	const decoded = segment.replace(/%2e/gi, ".");
	return decoded === "." || decoded === "..";
}
/**
* True when `path` passes {@link REQUEST_PATH_PATTERN} and holds no dot-segment. The caller checks
* the length before this call. Pure.
*
* @param path the request path.
*/
function isRequestPath(path) {
	return REQUEST_PATH_PATTERN.test(path) && !path.split("/").some(isDotSegment);
}
//#endregion
export { REQUEST_PATH_PATTERN, isDotSegment, isRequestPath };

//# sourceMappingURL=request-path.js.map